import React from 'react';
import { connect } from 'react-redux';
import './adminHistory.css';

import * as adminHistoryActions from '../store/adminHistorySlice';
import { adminHistorySelectors } from '../store/adminHistorySlice';
import * as productReleasesActions from '../store/productReleasesSlice';
import { productReleasesSelectors } from '../store/productReleasesSlice';
import * as objectHistoryActions from '../store/objectHistorySlice';
import { objectHistorySelectors } from '../store/objectHistorySlice';
import * as clientsActions from '../store/clientsSlice';
import { clientsSelectors } from '../store/clientsSlice';
import * as offlineLicensesActions from '../store/offlineLicensesSlice';
import { offlineLicensesSelectors } from '../store/offlineLicensesSlice';
import * as permanentLicensesActions from '../store/permanentLicensesSlice';
import { permanentLicensesSelectors } from '../store/permanentLicensesSlice';
import * as temporaryLicensesActions from '../store/temporaryLicensesSlice';
import { temporaryLicensesSelectors } from '../store/temporaryLicensesSlice';
import * as filterValuesActions from '../store/userConfigs/filterValuesSlice';
import * as accountsActions from '../store/accountsSlice';
import { accountsSelectors } from '../store/accountsSlice';
import * as webViewerServersActions from '../store/webViewerServersSlice';
import { webViewerServersSelectors } from '../store/webViewerServersSlice';
import * as webViewerLicensesActions from '../store/webViewerLicensesSlice';
import { webViewerLicensesSelectors } from '../store/webViewerLicensesSlice';
import * as trialRejectedDevicesActions from '../store/trialRejectedDevicesSlice';
import { trialRejectedDevicesSelectors } from '../store/trialRejectedDevicesSlice';
import { trialSettingsSelectors } from '../store/trialSettingsSlice';
import * as settingsActions from '../store/settingsSlice';
import { settingsSelectors } from '../store/settingsSlice';
import * as sortTablesActions from '../store/userConfigs/orderTablesSlice';
import { banSelectors, fetchBannedDevice } from '../store/banSlice';

import { Checkbox, Col, Grid, Row } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

import uniqueId from '../common/uniqueId';

import ClientHistoryTable from '../components/clientHisotryTable';
import OverlayLoader from '../components/overlayLoader';
import TooltipButtonGroup from '../components/tooltipButtonGroup';
import TooltipElement from '../components/tooltipElement';
import { ColumnFormatters } from '../components/tableColumnFilterFormatters';
import ProductReleaseHistoryTable from '../components/productReleaseHistoryTable';
import PermanentLicenseHistoryTable from '../components/permanentLicenseHistoryTable';
import TemporaryLicenseHistoryTable from '../components/temporaryLicenseHistoryTable';
import OfflineLicenseHistoryTable from '../components/offlineLicenseHistoryTable';
import FilterTableHeader from '../components/filterTableHeader';
import AccountsHistoryTable from '../components/accountsHistoryTable';
import WebViewerServerHistoryTable from '../components/webViewerServerHistoryTable';
import WebViewerLicenseHistoryTable from '../components/webViewerLicenseHistoryTable';
import TrialRejectedDeviceHistoryTable from '../components/trialRejectedDeviceHistoryTable';
import TrialSettingsHistoryTable from '../components/trialSettingsHistoryTable';
import BanHistoryTable from '../components/banHistoryTable';

import ClientHistoryTableHeader from '../components/clientHistoryTableHeader';
import ProductReleaseHistoryTableHeader from '../components/productReleaseHistoryTableHeader';
import PermanentLicenseHistoryTableHeader from '../components/permanentLicenseHistoryTableHeader';
import TemporaryLicenseHistoryTableHeader from '../components/temporaryLicenseHistoryTableHeader';
import OfflineLicenseHistoryTableHeader from '../components/offlineLicenseHistoryTableHeader';
import AccountsHistoryTableHeader from '../components/accountsHistoryTableHeader';
import WebViewerServerHistoryTableHeader from '../components/webViewerServerHistoryTableHeader';
import WebViewerLicenseHistoryTableHeader from '../components/webViewerLicenseHistoryTableHeader';
import TrialRejectedDeviceHistoryTableHeader from '../components/trialRejectedDeviceHistoryTableHeader';
import BanHistoryTableHeader from '../components/banHistoryTableHeader';

import setTitleToFilters from '../common/filtersTitles';
import { userConfigsSelectors } from '../store/userConfigs';
import { unwrapResult } from '@reduxjs/toolkit';

const ItemsPerPageModes = [10, 25, 30, 50, 100];

const thatObjectName = 'adminHistory';

const objectTypeCellNames = {
  'Client': 'Client',
  'ProductRelease': 'Product release',
  'PermanentOfflineLicense': 'Permanent offline license',
  'PermanentOnlineLicense': 'Permanent online license',
  'TemporaryOnlineLicense': 'Temporary online license',
  'AIAccount': 'AI account',
  'WebViewerServer': 'Web viewer server',
  'WebViewerLicense': 'Web viewer license',
  'TrialRejectedDevices': 'Trial rejected device',
  'TrialSettings': 'Trial Settings',
  'BanList': 'Ban list'
}

class AdminHistoryContainer extends React.Component {
  constructor(props) {
    super(props);

    this.historyLogColumns = [
      {
        dataField: 'objectType',
        text: 'Object type',
        sort: true,
        filter_: {
          type: 'select', values: {
            'All': '',
            'Client': 'client',
            'Product release': 'productRelease',
            'Permanent offline license': 'permanentOfflineLicense',
            'Permanent online license': 'permanentOnlineLicense',
            'Temporary online license': 'temporaryOnlineLicense',
            'AI account': 'AIAccount',
            'Web viewer server': 'WebViewerServer',
            'Web viewer license': 'WebViewerLicense',
            'Trial rejected device': 'TrialRejectedDevices',
            'Trial Settings': 'TrialSettings',
            'Ban list': 'BanList',
          }
        },
        formatter: (cell) => objectTypeCellNames[cell],
        defaultDisplayed: true,
        headerStyle: () => ({ maxWidth: '12em' })
      }, {
        dataField: 'objectName',
        text: 'Object name',
        sort: true,
        filter_: { type: 'text' },
        defaultDisplayed: true,
      }, {
        dataField: 'eventDateTime',
        text: 'Event time',
        sort: true,
        filter_: { type: 'datetime' },
        defaultDisplayed: true,
        headerStyle: () => ({ minWidth: '8em', maxWidth: '12em' }),
      }, {
        dataField: 'eventName',
        text: 'Event name',
        sort: true,
        filter_: { type: 'text' },
        defaultDisplayed: true,
      }, {
        dataField: 'user.login',
        text: 'User',
        sort: true,
        filter_: { type: 'text' },
        defaultDisplayed: true,
      },
    ].map(column => ({
      ...column,
      headerFormatter: this.createColumnFormatter(column.dataField, column.filter_.type, column.filter_.values),
      headerAttrs: { 'data-tooltip-type': column.filter_.type },
      reactKey: uniqueId(),
      onSort: (field, order) => {
        this.props.setOrderDirection(field, order);
      },
    }));

    this.state = {
      historyLog: {
        objectType: null,
        localId: 0,
        objectId: null,
        activeElement: null,
      },
      pagination: {
        sizePerPage: ItemsPerPageModes[0],
        page: 1,
      },
      data: [],
      filters: {},
      displayedColumns: this.historyLogColumns
        .filter((column) => column.defaultDisplayed !== undefined && column.defaultDisplayed)
        .map((column) => column.dataField),
    };
  }

  componentDidMount() {
    this.reloadHistory();

    this.props.fetchUserSettings().then(unwrapResult)
      .then(() => {
        this.setState({
          displayedColumns: this.historyLogColumns.filter(
            column => {
              const { visibleColumns } = this.props.settings;
              if (visibleColumns === undefined || visibleColumns === null)
                return column.defaultDisplayed !== undefined && column.defaultDisplayed;
              return visibleColumns.includes(column.dataField);
            }).map(column => column.dataField)
        });
      });
  }

  componentDidUpdate = prevProps => {
    setTitleToFilters();
    const { history } = this.props.adminHistory;
    if (history !== prevProps.adminHistory.history) {
      const { sizePerPage, page } = this.state.pagination;
      this.setState({
        data: [...history]
          .splice((page - 1) * sizePerPage, sizePerPage)
          .map(i => ({ ...i, id: `${i.objectType}${i.localId}${i.objectId}` })),
      });
    }
  };

  getObjectHistoryFunctions = (objectType, objectId, localId) => {
    const isExistCapture = !!objectId;
    switch (objectType) {
      case 'Client': {
        const { isFetching, fetchingError } = this.props.clients;
        const objectData = this.props.clients.entities[objectId];
        const props = {
          ...this.props.objectHistory.clients,
          isObjectLoading: isFetching,
          objectError: fetchingError,
          isExistCapture,
          editedFields: this.props.getClientsEditedFields(),
          objectData,
        };
        return {
          component: this.getComponentWithProps(
            props,
            ClientHistoryTable,
            'Client loading',
            ClientHistoryTableHeader,
          ),
          getHistory: () => {
            this.props.getClientById({ id: objectId });
            this.props.fetchObjectHistory(objectId, 'clients');
          },
          getHistoryByLocalId: () => {
            this.props.fetchObjectHistoryById(localId, 'clients');
          }
        };
      }
      case 'ProductRelease': {
        const { isFetching, fetchingError } = this.props.productReleases;
        const objectData = this.props.productReleases.entities[objectId];
        const props = {
          ...this.props.objectHistory.productReleases,
          isObjectLoading: isFetching,
          objectError: fetchingError,
          isExistCapture,
          editedFields: this.props.getProductReleasesEditedFields(),
          objectData,
        };
        return {
          component: this.getComponentWithProps(
            props,
            ProductReleaseHistoryTable,
            'Product release loading',
            ProductReleaseHistoryTableHeader,
          ),
          getHistory: () => {
            this.props.getProductReleaseById({ id: objectId });
            this.props.fetchObjectHistory(objectId, 'productReleases');
          },
          getHistoryByLocalId: () => {
            this.props.fetchObjectHistoryById(localId, 'productReleases');
          }
        };
      }
      case 'PermanentOfflineLicense': {
        const { isFetching, fetchingError } = this.props.offlineLicenses;
        const objectData = this.props.offlineLicenses.entities[objectId];
        const props = {
          ...this.props.objectHistory.offlineLicenses,
          isObjectLoading: isFetching,
          objectError: fetchingError,
          isExistCapture,
          editedFields: this.props.getOfflineLicensesEditedFields(),
          objectData,
        };
        return {
          component: this.getComponentWithProps(
            props,
            OfflineLicenseHistoryTable,
            'Permanent offline license loading',
            OfflineLicenseHistoryTableHeader,
          ),
          getHistory: () => {
            this.props.getOfflineLicenseById({ id: objectId });
            this.props.fetchObjectHistory(objectId, 'offlineLicenses');
          },
          getHistoryByLocalId: () => {
            this.props.fetchObjectHistoryById(localId, 'offlineLicenses');
          }
        };
      }
      case 'PermanentOnlineLicense': {
        const { isFetching, fetchingError } = this.props.permanentLicenses;
        const objectData = this.props.permanentLicenses.entities[objectId];
        const props = {
          ...this.props.objectHistory.permanentLicenses,
          isObjectLoading: isFetching,
          objectError: fetchingError,
          isExistCapture,
          editedFields: this.props.getPermanentLicensesEditedFields(),
          objectData,
        };
        return {
          component: this.getComponentWithProps(
            props,
            PermanentLicenseHistoryTable,
            'Permanent online license loading',
            PermanentLicenseHistoryTableHeader,
          ),
          getHistory: () => {
            this.props.getPermanentLicenseById({ id: objectId });
            this.props.fetchObjectHistory(objectId, 'permanentLicenses');
          },
          getHistoryByLocalId: () => {
            this.props.fetchObjectHistoryById(localId, 'permanentLicenses');
          }
        };
      }
      case 'TemporaryOnlineLicense': {
        const { isFetching, fetchingError } = this.props.temporaryLicenses;
        const objectData = this.props.temporaryLicenses.entities[objectId];
        const props = {
          ...this.props.objectHistory.temporaryLicenses,
          isObjectLoading: isFetching,
          objectError: fetchingError,
          isExistCapture,
          editedFields: this.props.getTemporaryLicensesEditedFields(),
          objectData,
        };
        return {
          component: this.getComponentWithProps(
            props,
            TemporaryLicenseHistoryTable,
            'Temporary online license loading',
            TemporaryLicenseHistoryTableHeader,
          ),
          getHistory: () => {
            this.props.getTemporaryLicenseById({ id: objectId });
            this.props.fetchObjectHistory(objectId, 'temporaryLicenses');
          },
          getHistoryByLocalId: () => {
            this.props.fetchObjectHistoryById(localId, 'temporaryLicenses');
          }
        };
      }
      case 'AIAccount': {
        const { isFetching, fetchingError } = this.props.accounts;
        const objectData = this.props.accounts.entities[objectId];
        const props = {
          ...this.props.objectHistory.accounts,
          isObjectLoading: isFetching,
          objectError: fetchingError,
          isExistCapture,
          objectData,
        };
        return {
          component: this.getComponentWithProps(
            props,
            AccountsHistoryTable,
            'AI account loading',
            AccountsHistoryTableHeader,
          ),
          getHistory: () => {
            this.props.getAccountById({ id: objectId });
            this.props.fetchObjectHistory(objectId, 'accounts');
          },
          getHistoryByLocalId: () => {
            this.props.fetchObjectHistoryById(localId, 'accounts');
          }
        };
      }
      case 'WebViewerServer': {
        const { isFetching, fetchingError } = this.props.webViewerServers;
        const objectData = this.props.webViewerServers.entities[objectId];
        const props = {
          ...this.props.objectHistory.webViewerServers,
          isObjectLoading: isFetching,
          objectError: fetchingError,
          isExistCapture,
          editedFields: this.props.getWebViewerServersEditedFields(),
          objectData,
        };
        return {
          component: this.getComponentWithProps(
            props,
            WebViewerServerHistoryTable,
            'Web viewer server loading',
            WebViewerServerHistoryTableHeader,
          ),
          getHistory: () => {
            this.props.getWebViewerServerById({ id: objectId });
            this.props.fetchObjectHistory(objectId, 'webViewerServers');
          },
          getHistoryByLocalId: () => {
            this.props.fetchObjectHistoryById(localId, 'webViewerServers');
          }
        };
      }
      case 'WebViewerLicense': {
        const { isFetching, fetchingError } = this.props.webViewerLicenses;
        const objectData = this.props.webViewerLicenses.entities[objectId];
        const props = {
          ...this.props.objectHistory.webViewerLicenses,
          isObjectLoading: isFetching,
          objectError: fetchingError,
          isExistCapture,
          editedFields: this.props.getWebViewerLicensesEditedFields(),
          objectData,
        };
        return {
          component: this.getComponentWithProps(
            props,
            WebViewerLicenseHistoryTable,
            'Web viewer license loading',
            WebViewerLicenseHistoryTableHeader,
          ),
          getHistory: () => {
            this.props.getWebViewerLicenseById({ id: objectId });
            this.props.fetchObjectHistory(objectId, 'webViewerLicenses');
          },
          getHistoryByLocalId: () => {
            this.props.fetchObjectHistoryById(localId, 'webViewerLicenses');
          }
        };
      }
      case 'TrialRejectedDevices': {
        const { isFetching, fetchingError } = this.props.trialRejectedDevices;
        const objectData = this.props.trialRejectedDevices.entities[objectId];
        const props = {
          ...this.props.objectHistory.trialRejectedDevices,
          isObjectLoading: isFetching,
          objectError: fetchingError,
          isExistCapture,
          editedFields: this.props.getTrialRejectedDevicesEditedFields(),
          objectData,
        };
        return {
          component: this.getComponentWithProps(
            props,
            TrialRejectedDeviceHistoryTable,
            'Trial rejected device loading',
            TrialRejectedDeviceHistoryTableHeader,
          ),
          getHistory: () => {
            this.props.getTrialRejectedDeviceById({ id: objectId });
            this.props.fetchObjectHistory(objectId, 'trialRejectedDevices');
          },
          getHistoryByLocalId: () => {
            this.props.fetchObjectHistoryById(localId, 'trialRejectedDevices');
          }
        };
      }
      case 'TrialSettings': {
        const { isFetching, fetchingError } = this.props.trialSettings;
				const objectData = this.props.trialSettings;
				const props = {
					...this.props.objectHistory.trialSettings,
					isObjectLoading: isFetching,
					objectError: fetchingError,
					isExistCapture,
					editedFields: this.props.getTrialSettingsEditedFields(),
					objectData,
				};

				return {
					component: this.getComponentWithProps(
						props,
						TrialSettingsHistoryTable,
						'Trial settings loading',
						() => {
							return null;
						}
					),
					getHistory: () => {
						// this.props.getTrialRejectedDeviceById({ id: objectId });
						this.props.fetchObjectHistory(objectId, 'trialSettings');
					},
					getHistoryByLocalId: () => {
						this.props.fetchObjectHistoryById(localId, 'trialSettings');
					},
        };
      }
      case 'BanList': {
        const { isFetching, fetchingError } = this.props.babbedDevices;
        const objectData = this.props.babbedDevices.entities[objectId];

        const props = {
          ...this.props.objectHistory.banHistory,
          isObjectLoading: isFetching,
          objectError: fetchingError,
          isExistCapture,
          editedFields: this.props.getTrialSettingsEditedFields(),
          objectData,
        };

        return {
          component: this.getComponentWithProps(
            props,
            BanHistoryTable,
            'Ban history loading',
            BanHistoryTableHeader
          ),
          getHistory: () => {
            this.props.getBannedDeviceById({ id: objectId });
            this.props.fetchObjectHistory(objectId, objectHistoryActions.objectHistoryNames.banHistory);
          },
          getHistoryByLocalId: () => {
            this.props.fetchObjectHistoryById(localId, objectHistoryActions.objectHistoryNames.banHistory);
          }
        };
      }
      default:
        return {
          component: null,
          getHistory: () => [],
          getHistoryByLocalId: () => [],
        }
    }
  };

  renderButtons = () => (
    <TooltipButtonGroup>
      <TooltipElement type="button" text="Filter / Refresh" icon="filter" onClick={this.reloadHistory} />
    </TooltipButtonGroup>
  );

  render() {
    return (
      <OverlayLoader active={this.isLoading()} text={this.getLoaderMessage()}>
        <Grid>
          <h1>Admin history</h1>
          {this.renderButtons()}
          <Row>
            <Col md={6}>
              {this.renderContent()}
            </Col>
            <div className="right-container">
              <Col md={6}>
                <div className="history-log-container">
                  {this.renderObjectHistoryLog()}
                </div>
              </Col>
            </div>
          </Row>
        </Grid>
      </OverlayLoader>
    );
  }

  renderObjectHistoryLog = () => {
    if (this.props.adminHistory.error) this.renderError();
    const { objectType, objectId } = this.state.historyLog;
    const { component } = this.getObjectHistoryFunctions(objectType, objectId);
    return component;
  };

  renderContent = () => [this.renderError(), this.renderHistoryLog()];

  onDisplayedColumnsChanged = (isChecked, columnName) => {
    this.setState({
      displayedColumns: isChecked ? [
        ...this.state.displayedColumns, columnName
      ] : this.state.displayedColumns.filter(column => column !== columnName)
    }, () => this.props.addUserSettings({ visibleColumns: this.state.displayedColumns }));
  };

  renderHistoryLog = () => {
    const { pagination, displayedColumns, data } = this.state;
    const { filters, sort } = this.props;
    const isAnyFilterApplied = Object.keys(filters).length !== 0;
    const paginationOptions = {
      sizePerPageList: ItemsPerPageModes,
      page: pagination.page,
      sizePerPage: pagination.sizePerPage,
      totalSize: this.props.adminHistory.history.length,
    };

    const selectRow = {
      mode: 'radio',
      clickToSelect: true,
      hideSelectColumn: true,
      onSelect: this.handleOnSelect,
    };

    return (
      <div>
        <div>
          {this.historyLogColumns.map(column => <Checkbox
            key={column.reactKey}
            inline
            checked={displayedColumns.includes(column.dataField)}
            onChange={e => this.onDisplayedColumnsChanged(e.target.checked, column.dataField)}
          >
            {column.text}
          </Checkbox>)}
        </div>
        <FilterTableHeader total={this.props.adminHistory.history.length} clearFilters={this.clearFilters} isAnyFilterApplied={isAnyFilterApplied} />
        <BootstrapTable
          remote
          keyField="id"
          data={data}
          columns={this.historyLogColumns.filter((column) => displayedColumns.includes(column.dataField))}
          pagination={paginationFactory(paginationOptions)}
          classes="autoWithColumnTable"
          onTableChange={(...args) => this.onTableChange(filters, sort, ...args)}
          defaultSorted={[sort]}
          noDataIndication="History is empty"
          selectRow={selectRow}
          rowClasses="admin-history-table-row"
        />
      </div>
    );
  };

  onTableChange = (filters, sort, type, { page, sizePerPage, sortField, sortOrder }) => {
    const adminHistory = this.props.adminHistory.history;
    if (type === 'pagination') {
      this.setState({ pagination: { page, sizePerPage } });
      let isLoaded = true;
      for (let i = (page - 1) * sizePerPage; i < page * sizePerPage; ++i) {
        if (adminHistory[i] === null) {
          isLoaded = false;
          break;
        }
      }
      if (isLoaded) {
        this.setState({
          data: [...adminHistory]
            .splice((page - 1) * sizePerPage, sizePerPage)
            .map(i => ({ ...i, id: `${i.objectType}${i.localId}${i.objectId}` })),
        });
        return;
      }
      this.props.fetchNextHistory({
        filters, sort, limit: sizePerPage, offset: (page - 1) * sizePerPage,
      });
    } else if (type === 'sort') {
      if ((sort.dataField === sortField) && (sort.order === sortOrder)) {
        return;
      }
      this.setState({ sort: { dataField: sortField, order: sortOrder } }, this.reloadHistory);
    }
  };

  handleOnSelect = (item, isSelect, row, el) => {
    const { activeElement, objectId: prevObjectId, objectType: prevObjectType } = this.state.historyLog;
    const { currentTarget } = el;
    const { objectType, localId, objectId } = item;

    if (activeElement === currentTarget) return;
    if (activeElement) activeElement.classList.remove('bg-primary');

    currentTarget.classList.add('bg-primary');

    const isNewItem = (prevObjectId !== objectId || prevObjectType !== objectType) || objectId === null;
    this.setState({
      ...this.state,
      historyLog: { objectType, localId, objectId, activeElement: currentTarget },
    }, () => this.getHistory(isNewItem));
  };

  getHistory = (isNewItem) => {
    const { objectType, objectId, localId } = this.state.historyLog;
    if (!isNewItem) return;
    const { getHistory, getHistoryByLocalId } = this.getObjectHistoryFunctions(objectType, objectId, localId);
    if (objectId === null) {
      getHistoryByLocalId();
    } else {
      getHistory();
    }
  };

  getComponentWithProps = (props, Component, loadingText, TableHeaderComponent) => {
    const { data = [], error: fetchHistoryError, isFetching, isObjectLoading, objectError, isExistCapture, editedFields, objectData } = props;
    const { historyLog: { localId } } = this.state;
    if (fetchHistoryError) return this.renderObjectError(`Failed to fetch object history: ${fetchHistoryError}`);
    if (objectError) return this.renderObjectError(`Failed to fetch object item: ${objectError}`);

    const selectRow = {
      mode: 'radio',
      classes: 'bg-primary',
      clickToSelect: false,
      hideSelectColumn: true,
      selected: [localId],
    };
    const paginationOptions = { sizePerPage: data.length };
    return this.withOverlayLoader(
      isFetching || isObjectLoading,
      loadingText,
      isFetching ? null :
        <div>
          {isExistCapture && <TableHeaderComponent editedFields={editedFields} objectData={objectData} />}
          <Component selectRow={selectRow} history={data} paginationOptions={paginationOptions} />
        </div>
    )
  };

  createColumnFormatter = (name, filterType, values) => {
    if (ColumnFormatters[filterType] === undefined) return null;

    return (column, colIndex, { sortElement, filterElement }) => {
      const params = {
        value: this.props.filters[name],
        onEnter: this.reloadHistory
      };
      const onChanged = (filterType) === 'select' ? this.reloadHistory : () => {
      };
      if (values !== undefined) params['filterValues'] = values;

      params['onChange'] = (value) => this.changeFilter(name, value, onChanged);
      return ColumnFormatters[filterType](column, colIndex, { sortElement, filterElement }, params);
    };
  };

  renderError = () => {
    const error =
      this.props.settingsFetchingError ||
      this.props.settingsAddingError ||
      this.props.adminHistory.error ||
      null;

    return error && <p className="text-danger">Error: {error.toString()}</p>;
  };

  changeFilter = (colName, value, onChanged) => {
    this.props.setFilterValue(colName, value).then(onChanged);
  };

  clearFilters = () => {
    this.props.clearFilters().then(this.reloadHistory);
  };

  reloadHistory = () => {
    const { pagination } = this.state;
    const { sort, filters } = this.props;
    this.setState({
      pagination: {
        ...pagination,
        page: 1,
      },
      historyLog: {
        objectType: null,
        localId: null,
        activeElement: null,
        objectId: null,
      },
    }, () => {
      this.props.fetchStartHistory({
        filters, sort, limit: pagination.sizePerPage
      });
    });
  };

  renderObjectError = (errorMessage) => {
    return <div><span className='text-danger'>{errorMessage}</span></div>
  };

  withOverlayLoader = (isFetching, text, children) => {
    return (
      <OverlayLoader active={isFetching} text={text}>
        {children}
      </OverlayLoader>
    );
  };

  isLoading = () => {
    return this.props.adminHistory.isFetching || this.props.isSettingsFetching;
  };

  getLoaderMessage = () => {
    if (this.props.adminHistory.isFetching) return "Admin history loading...";
    if (this.props.isSettingsFetching) return "User settings loading...";
  };
}

const mapStateToProps = (state) => {
  return {
    objectHistory: objectHistorySelectors.objectHistoryState(state),
    adminHistory: adminHistorySelectors.adminHistoryState(state),
    clients: clientsSelectors.state(state),
    productReleases: productReleasesSelectors.state(state),
    temporaryLicenses: temporaryLicensesSelectors.state(state),
    offlineLicenses: offlineLicensesSelectors.state(state),
    permanentLicenses: permanentLicensesSelectors.state(state),
    accounts: accountsSelectors.state(state),
    webViewerServers: webViewerServersSelectors.state(state),
    webViewerLicenses: webViewerLicensesSelectors.state(state),
    babbedDevices: banSelectors.state(state),
    trialRejectedDevices: trialRejectedDevicesSelectors.state(state),
    trialSettings: trialSettingsSelectors.state(state),

    filters: userConfigsSelectors.filterValues(state, thatObjectName),
    sort: userConfigsSelectors.sortTables(state, thatObjectName),
    settings: settingsSelectors.adminHistory(state),
    isSettingsFetching: settingsSelectors.isFetching(state),
    settingsFetchingError: settingsSelectors.fetchingError(state),
    settingsAddingError: settingsSelectors.addingError(state),

    getClientsEditedFields: () => objectHistorySelectors.clientsEditedFields(state),
    getProductReleasesEditedFields: () => objectHistorySelectors.productReleasesEditedFields(state),
    getOfflineLicensesEditedFields: () => objectHistorySelectors.offlineLicensesEditedFields(state),
    getPermanentLicensesEditedFields: () => objectHistorySelectors.permanentLicensesEditedFields(state),
    getTemporaryLicensesEditedFields: () => objectHistorySelectors.temporaryLicensesEditedFields(state),
    getWebViewerServersEditedFields: () => objectHistorySelectors.webViewerServersEditedFields(state),
    getWebViewerLicensesEditedFields: () => objectHistorySelectors.webViewerLicensesEditedFields(state),
    getTrialRejectedDevicesEditedFields: () => objectHistorySelectors.trialRejectedDevicesEditedFields(state),
    getTrialSettingsEditedFields: () => objectHistorySelectors.trialSettingsEditedFields(state),
  };
};

const actionCreators = {
  fetchStartHistory: adminHistoryActions.fetchStartHistory,
  fetchNextHistory: adminHistoryActions.fetchNextHistory,

  fetchObjectHistory: objectHistoryActions.fetchHistory,
  fetchObjectHistoryById: objectHistoryActions.fetchHistoryById,

  getClientById: clientsActions.fetchById,
  getProductReleaseById: productReleasesActions.fetchById,
  getOfflineLicenseById: offlineLicensesActions.fetchById,
  getPermanentLicenseById: permanentLicensesActions.fetchById,
  getTemporaryLicenseById: temporaryLicensesActions.fetchById,
  getAccountById: accountsActions.fetchById,
  getWebViewerServerById: webViewerServersActions.fetchById,
  getWebViewerLicenseById: webViewerLicensesActions.fetchById,
  getTrialRejectedDeviceById: trialRejectedDevicesActions.fetchById,
  getBannedDeviceById: fetchBannedDevice,

  setFilterValue: (filterName, value) =>
    filterValuesActions.setFilterValue(thatObjectName, filterName, value),
  clearFilters: () => filterValuesActions.clearFilters(thatObjectName),

  fetchUserSettings: () => settingsActions.fetchUserSettings({ objectName: thatObjectName }),
  addUserSettings: (settings) => settingsActions.postUserSettings({ objectName: thatObjectName, settings }),
  setOrderDirection: (dataField, order) =>
    sortTablesActions.setSortDirection(thatObjectName, dataField, order),
};

export default connect(mapStateToProps, actionCreators)(AdminHistoryContainer);



// WEBPACK FOOTER //
// ./src/containers/adminHistoryContainer.js